<template>
  <div class="bg-light-primary">
    <h4 :class="titleClass">{{ day }}</h4>
    <IconCircle :width="17" :height="17" class="my-2px"/>
    <h4 class="text-small --prm-light --w-bold">
      {{ point | toThousands }}
    </h4>
  </div>
</template>

<script>
import IconCircle from '@/components/icons/IconCircle'

export default {
  name: 'Vacant',
  props: {
    day: Number,
    weekDay: Number,
    point: Number
  },
  components: {
    IconCircle
  },
  computed: {
    titleClass () {
      let _class = 'text-medium --w-bold mb-2'
      if (this.weekDay === 1) _class += '--c-pink'
      else _class += '--c-dark'
      return _class
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  height: 77px;
}
</style>
